/**
 * Class names for one task row of the timesheet grid (#113, #114).
 *
 * Each grid row is a `display: contents` wrapper, so its children are siblings in
 * one CSS grid with the project group headers. That rules out `:nth-child` /
 * `:nth-of-type` zebra striping: the count would run straight through every group
 * header and the stripe phase would drift from group to group. So the parity is
 * computed here, from the row's index WITHIN ITS OWN GROUP, and every group starts
 * on an unshaded row directly under its header.
 *
 * The note-open marker exists because the note popover takes focus out of the row,
 * which ends `:focus-within`; the row has to stay identified while its note is
 * being edited. It is driven by the grid's existing `openNoteLineId` — there is no
 * second "active row" state.
 */
export const TASK_ROW_CLASS = 'ts-row';
export const TASK_ROW_STRIPED_CLASS = 'ts-row--striped';
export const TASK_ROW_NOTE_OPEN_CLASS = 'ts-row--note-open';

export interface TaskRowState {
  /** Zero-based position of the row inside its own project / category group. */
  indexInGroup: number;
  /** Whether this row's note popover is the one currently open. */
  isNoteOpen: boolean;
}

export function taskRowClassName({ indexInGroup, isNoteOpen }: TaskRowState): string {
  const classes = [TASK_ROW_CLASS];
  // Second, fourth, … row of a group. The first row stays white so the group
  // group header above it always sits on white, never on a shaded row.
  if (indexInGroup % 2 === 1) classes.push(TASK_ROW_STRIPED_CLASS);
  if (isNoteOpen) classes.push(TASK_ROW_NOTE_OPEN_CLASS);
  return classes.join(' ');
}
